import {createSelector} from 'reselect';

import {LayoutsPageState, layoutsSelectors} from './layoutsSlice';

export const makeSelectLayoutsByKey = (queryKey: string) =>
    createSelector(
        [
            (state: LayoutsPageState) => state.userPage.tabs.content.layouts.queries[queryKey],
            (state: LayoutsPageState) => layoutsSelectors.selectEntities(state),
        ],
        (query, entities) => {
            if (!query) {
                return {items: [], total: 0, status: 'idle' as const, error: undefined};
            }
            return {
                items: (query.ids ?? []).map((id: string) => entities[id]!),
                total: query.total,
                status: query.status,
                error: query.error,
            };
        },
    );

export const selectReceivedAt = (state: LayoutsPageState, queryKey: string) =>
    state.userPage.tabs.content.layouts.queries[queryKey]?.receivedAt;
